/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Injectable} from '@angular/core';
import {Router} from "@angular/router";

import {AuthenticationService} from './authentication.service';
import {BaseService} from "./base-service";

import {DriverObject} from '../models/driver-object';
import {DriverObjectInstance} from '../models/driver-object-instance';
import { PagedResults } from 'app/models/paged-results';
import { RestService } from './rest-service';
import { Url_Base } from 'app/rest-constants';

@Injectable()
export class DriverObjectService extends BaseService {

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private mRestService: RestService
  ) {
    super(router, authenticationService);
  }

  private getUrl(): string {
    return `${Url_Base}/driver-objects/`;
  }

  getNumberDriverObjects(): Promise<Number> {
    const callUrl = this.getUrl() + 'count';
    return this.mRestService.get<Number>(callUrl);
  }

  getNumberDriverObjectInstances(): Promise<Number> {
    const callUrl = this.getUrl() + 'instances/count';
    return this.mRestService.get<Number>(callUrl);
  }

  getAllDriverObjectsForPaging(start: number, size: number, order: String, filterString: String): Promise<PagedResults<DriverObject>> {
    const callUrl = this.getUrl() + 'paging?start=' + start + "&size=" + size + "&order=ASC&filterColumn=name&filterString=" + filterString;

    return this.mRestService.get<PagedResults<DriverObject>>(callUrl);
  }

  getAllDriverObjectInstancesForPaging(start: number, size: number, order: String, filterString: String): Promise<PagedResults<DriverObjectInstance>> {
    const callUrl = this.getUrl() + 'instances/paging?start=' + start + "&size=" + size + "&order=ASC&filterColumn=name&filterString=" + filterString;

    return this.mRestService.get<PagedResults<DriverObjectInstance>>(callUrl);
  }

  getAllDriverObjects(): Promise<DriverObject[]> {
    const callUrl = this.getUrl();
    return this.mRestService.get<DriverObject[]>(callUrl);
  }

  getDriverObjectById(id: number): Promise<DriverObject> {
    const callUrl = this.getUrl() + `${id}`;
    return this.mRestService.get<DriverObject>(callUrl);
  }

  createDriverObject(driverObject: DriverObject): Promise<DriverObject> {
    const callUrl = this.getUrl();
    return this.mRestService.post<DriverObject>(callUrl, driverObject);
  }

  updateDriverObject(driverObject: DriverObject): Promise<DriverObject> {
    const callUrl = this.getUrl();
    return this.mRestService.put<DriverObject>(callUrl, driverObject);
  }

  deleteDriverObjects(ids: number[]): Promise<any> {
    const callUrl = this.getUrl();
    return this.mRestService.delete(callUrl, ids);
  }


   /*-----------------------INSTANCE FUNCTIONS FOR ANTENNA -------------------------*/


  getAllDriverObjectInstances(): Promise<DriverObjectInstance[]> {
    const callUrl = this.getUrl() + 'instances';
    return this.mRestService.get<DriverObjectInstance[]>(callUrl);
  }

  getDriverObjectInstancesFiltered(start: number, size: number, order: string, filterString: string): Promise<DriverObjectInstance[]> {
    const url = this.getUrl() + `instances/filtered?start=` + start + "&size=" + size + "&order=" + order + "&filterColumn=name&filterString=" + filterString;
    return this.mRestService.get<DriverObjectInstance[]>(url);
  }

  getDriverObjectInstanceById(id: number): Promise<DriverObjectInstance> {
    const callUrl = this.getUrl() + `instances/${id}`;
    return this.mRestService.get<DriverObjectInstance>(callUrl);
  }

  createDriverObjectInstance(driverObjectInstance: DriverObjectInstance): Promise<DriverObjectInstance> {
    const callUrl = this.getUrl() + 'instances';
    return this.mRestService.post<DriverObjectInstance>(callUrl, driverObjectInstance);
  }

  updateDriverObjectInstance(driverObjectInstance: DriverObjectInstance): Promise<DriverObjectInstance> {
    const callUrl = this.getUrl() + 'instances';
    return this.mRestService.put<DriverObjectInstance>(callUrl, driverObjectInstance);
  }

  deleteDriverObjectInstances(ids: number[]): Promise<any> {
    const callUrl = this.getUrl() + `instances`;
    return this.mRestService.delete(callUrl, ids);
    }

}
